import { render, staticRenderFns } from "./CustomerInfoFields.vue?vue&type=template&id=0ee4abf9&"
import script from "./CustomerInfoFields.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
